export const async = () => ({
    loading: false,
    error: false
})

export const GET_ASYNC = (state, payload) =>
    payload && payload.field ? { loading: state[payload.field].loading, error: state[payload.field].error } : { loading: state.loading, error: state.error }

export const ASYNC_MUTATIONS = () => ({
    REQUEST: (state, payload) => {
        if (payload && payload.field) {
            state[payload.field].error = false
            state[payload.field].loading = true
        } else {
            state.error = false
            state.loading = true
        }
    },
    SUCCESS: (state, payload) => {
        if (payload && payload.field) {
            state[payload.field].error = false
            state[payload.field].loading = false
        } else {
            state.error = false
            state.loading = false
        }
    },
    ERROR: (state, payload) => {
        if (payload && payload.field) {
            state[payload.field].error = payload
            state[payload.field].loading = false
        } else {
            state.error = payload
            state.loading = false
        }
    },
    CLEAR: (state, payload) => {
        if (payload && payload.field) {
            state[payload.field].error = false
            state[payload.field].loading = false
        } else {
            state.error = false
            state.loading = false
        }
    }
})
